import * as React from 'react';
import { Text } from 'components';

type DataSet = { label: string; value: string }[];

type DataSetsTableProps = {
  dataSets: DataSet[];
  columnClassName?: string;
};

const DataSetsTable: React.FunctionComponent<DataSetsTableProps> = ({
  dataSets,
  columnClassName = 'col-md-6',
}) => (
    <div className="row">
      {dataSets.map((dataSet, dataSetIndex) => (
        <div key={dataSetIndex} className={columnClassName}>
          {dataSet.map(({ label, value }, dataIndex) => (
            <div key={dataIndex}>
              <Text strong>{label} </Text>
              <Text type="secondary">{value}</Text>
            </div>
          ))}
        </div>
      ))}
    </div>
  );

export default DataSetsTable;
